export interface RowActions {
  delete: () => void;
}
